import FormInputUpload from '../Partials/FormInputUpload';
import GeneralForm from './../Forms/GeneralForm';
import FormInputText from './../Partials/FormInputText';

const LaravelJobConditionPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: [
                {
                    field: "meta_title",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("meta", "meta_title");
                            },
                            required: true,
                            label: "عنوان متا"
                        }
                    }
                }
            ],
            contents: [
                {
                    field: "abilities",
                    partial: {
                        handler: (props) => {
                            return props.formHandler.buildArrayInputs("contents", "abilities", "توانایی ها")
                        },
                    }
                },
                {
                    field: "device_image",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "device_image");
                            },
                            required: true,
                            label: "عکس کامپیوتر",
                            direction: "ltr"
                        }
                    }
                },
                {
                    field: "mobile_image",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "mobile_image");
                            },
                            required: true,
                            label: "عکس موبایل",
                            direction: "ltr"
                        }
                    }
                },
                {
                    field: "thumb",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "thumb");
                            },
                            required: true,
                            label: "عکس کوچک",
                            direction: "ltr"
                        }
                    }
                },
                {
                    field: "features",
                    partial: {
                        handler: (props) => {
                            return props.formHandler.buildArrayInputs("contents", "features", "شرایط کاری")
                        },
                    }
                },
                {
                    field: "tags",
                    partial: {
                        handler: (props) => {
                            return props.formHandler.buildArrayInputs("contents", "tags", "برچسب ها")
                        },
                    }
                },
                {
                    field: "occupation",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "occupation");
                            },
                            required: true,
                            label: "فرصت شغلی"
                        }
                    }
                },
                {
                    field: "contract_type",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "contract_type");
                            },
                            required: true,
                            label: "نوع قرارداد"
                        }
                    }
                },
                {
                    field: "email",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "email");
                            },
                            required: true,
                            label: "ایمیل",
                            direction: "ltr"
                        }
                    }
                }
            ]
        }
    }
};

export default LaravelJobConditionPageBuilder





// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/LaravelJobConditionPageBuilder.js